import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';

import { EditQuestionTemplate, useQuestionEdit } from '@/features/question-library';

export const Route = createFileRoute('/_authenticated/question-library/$questionId/')({
  component: EditQuestionPage,
});

function EditQuestionPage() {
  const { questionId } = Route.useParams();
  const navigate = useNavigate();

  const { question, isLoading, save, isSaving } = useQuestionEdit(questionId);

  // ✅ redirects DEPOIS dos hooks
  if (!isLoading && !question) {
    return <Navigate to="/question-library" replace />;
  }

  function handleCancel() {
    void navigate({ to: '/question-library' });
  }

  return (
    <EditQuestionTemplate
      question={question}
      isLoading={isLoading}
      isSaving={isSaving}
      onSave={save}
      onCancel={handleCancel}
    />
  );
}
